import React, { useState } from "react";
import "./BranchLocator.css";
import { FaMapMarkerAlt } from "react-icons/fa";

const BranchLocator = ({ data = [] }) => {
  const [selectedCenter, setSelectedCenter] = useState(null);

  const openPopup = (center) => {
    setSelectedCenter(center);
  };

  const closePopup = () => {
    setSelectedCenter(null);
  };

  return (
    <div className="centers-wrapper">
      <h2 className="centers-title">
        Find Out Your Nearest <span>Branch</span>
      </h2>

      {data.map((section, index) => (
        <div key={index} className="centers-section">
          <h2 className="section-title">
            {section.title}{" "}
            {section.state && <span className="highlight">{section.state}</span>}
          </h2>

          <div className="centers-grid">
            {section.centers.map((center, i) => (
              <div className="center-card" key={i}>
                <div className="center-header">
                  <h3 className="center-name">{center.name}</h3>

                  <a href={center.map} target="_blank" rel="noreferrer">
                    <FaMapMarkerAlt className="center-location-icon" />
                  </a>
                </div>

                <button className="show-more" onClick={() => openPopup(center)}>
                  Show More
                </button>
              </div>
            ))}
          </div>
        </div>
      ))}

      {/* POPUP MODAL */}
      {selectedCenter && (
        <div className="modal-overlay" onClick={closePopup}>
          <div
            className="modal-box"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={closePopup}>
              ✖
            </button>

            <h2 className="modal-title">{selectedCenter.name}</h2>

            {selectedCenter.address && (
              <p className="modal-info">
                <strong>Address:</strong> {selectedCenter.address}
              </p>
            )}

            {selectedCenter.head && (
              <p className="modal-info">
                <strong>Center Head:</strong> {selectedCenter.head}
              </p>
            )}

            {selectedCenter.pin && (
              <p className="modal-info">
                <strong>PIN:</strong> {selectedCenter.pin}
              </p>
            )}

            {selectedCenter.call && (
              <p className="modal-info">
                <strong>Call:</strong> {selectedCenter.call}
              </p>
            )}

            {selectedCenter.email && (
              <p className="modal-info">
                <strong>Email:</strong> {selectedCenter.email}
              </p>
            )}

            {selectedCenter.map && (
              <a href={selectedCenter.map} target="_blank" className="modal-map-btn">
                View Location
              </a>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default BranchLocator;
